import Accordion from '../../../../ui/accordion/accordion';
import { IRoutes } from '../../../../../routes';
import { IUser } from 'src/utils/interfaces/user';
import { NavLink } from 'react-router-dom';
import { Permissions } from 'src/utils/enums/permissions.enum';
import { useTranslation } from 'react-i18next';
import { dialogModalHandler, isAllow } from 'src/utils/helpers';
import {
    LABEL_TEXT_MENU_MANAGE_USER,
    LABEL_TEXT_MENU_SYSTEM_ADMIN,
} from 'src/localization/resouceKeys';
import { useDispatch, useSelector } from 'react-redux';

import '../assets/navigationItem.scss';

interface IArgs extends IRoutes {
    dealer?: string;
    permissionsMap: Map<string, Array<string>>;
    isOpen?: boolean;
    onToggle?: () => void;
}

const FIELD_USER = 'field';

const NavigationItem = ({
    path,
    name,
    icon,
    childs,
    permissions,
    dealer,
    permissionsMap,
    isOpen,
    onToggle,
}: IArgs) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const baseIndex = 0;

    const dialogModal = useSelector((state: IUser) => state.dialogModal);
    const accessUser = useSelector((state: IUser) => state.accessUser);

    if (childs && childs.length) {
        const children: Array<JSX.Element> = [];

        childs.forEach((childRoute, index) => {
            const shouldRender = childRoute.permissions
                ? isAllow(childRoute.permissions, permissionsMap, dealer)
                : true;

            if (shouldRender) {
                children.push(
                    <li key={index}>
                        <NavLink
                            to={childRoute.path}
                            onClick={(event) =>
                                dialogModalHandler(event, dispatch, dialogModal)
                            }
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: t(childRoute.name),
                                }}
                            />
                        </NavLink>
                    </li>,
                );
            }
        });

        return children.length > baseIndex ? (
            <li key={name}>
                <Accordion
                    title={name}
                    icon={icon}
                    isOpen={isOpen}
                    onToggle={onToggle}
                    content={<ul className='c-icon-list childs'>{children}</ul>}
                />
            </li>
        ) : null;
    }

    const hasPermission = permissions
        ? isAllow(permissions, permissionsMap, dealer)
        : true;

    const hasFieldUserDsmPermission =
        Boolean(accessUser) &&
        (permissionsMap
            .get(Permissions.DEALER_SECURITY_MAINTENANCE)
            ?.includes(FIELD_USER) ??
            false);

    const isManageUserRestricted =
        name === LABEL_TEXT_MENU_MANAGE_USER && Boolean(accessUser);

    const isFieldUserSystemAdminAllowed =
        name === LABEL_TEXT_MENU_SYSTEM_ADMIN && hasFieldUserDsmPermission;

    const shouldRender =
        name === LABEL_TEXT_MENU_SYSTEM_ADMIN
            ? hasPermission || isFieldUserSystemAdminAllowed
            : hasPermission && !isManageUserRestricted;

    return shouldRender ? (
        <li>
            <NavLink
                to={path}
                end
                onClick={(event) =>
                    dialogModalHandler(event, dispatch, dialogModal)
                }
            >
                {icon && (
                    <i
                        className={`c-icon-list__icon c-icon c-icon--[${icon}]`}
                        aria-hidden='true'
                        role='img'
                    />
                )}

                <span
                    dangerouslySetInnerHTML={{
                        __html: t(name),
                    }}
                />
            </NavLink>
        </li>
    ) : null;
};

export default NavigationItem;
